import {API_URLS} from '@px/const/urls';
import {http} from '@px/helper/http';

export const favoriteApi = {
  groupsAll() {
    return http.get(API_URLS.MARKET_FAVORITE_GROUPS, {});
  },
  groupAdd(params) {
    return http.post(API_URLS.MARKET_FAVORITE_GROUPS_ADD, {params});
  },
  groupDelete(params) {
    return http.post(API_URLS.MARKET_FAVORITE_GROUPS_DELETE, {params});
  },
  groupRename(params) {
    return http.post(API_URLS.MARKET_FAVORITE_GROUPS_RENAME, {params});
  },
  instrumentAdd(params) {
    return http.post(API_URLS.MARKET_FAVORITE_INSTRUMENT_add, {params});
  },
  instrumentDelete(params) {
    return http.post(API_URLS.MARKET_FAVORITE_INSTRUMENT_DELETE, {params});
  },
  instrumentTop(params) {
    return http.post(API_URLS.MARKET_FAVORITE_INSTRUMENT_TOP, {params});
  },
  instrumentSort(params) {
    return http.post(API_URLS.MARKET_FAVORITE_INSTRUMENT_SORT, {params});
  },
};
